import { Grid, Typography } from "@mui/material";
import { UserResponse } from "../../../redux/User/userApi";

type Props = {
  clientId: number;
  hiringManagerUser?: UserResponse;
  modifiedSlotList?: number;
};

const BookingMessage = ({
  clientId,
  hiringManagerUser,
  modifiedSlotList = 0,
}: Props) => {
  return (
    <Grid
      container
      item
      justifyContent={"center"}
      alignItems={"center"}
      height={"38px"}
      bgcolor={modifiedSlotList > 0 ? "#FDE0D0" : "#F0E9FC"}
      borderRadius={1}
      mb={1}
      mx={4}
    >
      {modifiedSlotList > 0 ? (
        <Typography
          fontSize={"16px"}
          lineHeight={"18px"}
          fontWeight={500}
          color={"#E61A1A"}
          letterSpacing={"0.1px"}
        >
          The timeslots are not booked yet .To book desired timeslots, click on
          the book timeslot button.
        </Typography>
      ) : (
        <Typography
          fontSize={"16px"}
          lineHeight={"18px"}
          fontWeight={500}
          letterSpacing={"0.1px"}
        >
          {!!clientId &&
            !!hiringManagerUser &&
            `You are booking slots for ${hiringManagerUser.firstName}`}
          {!!clientId &&
            !hiringManagerUser &&
            "Please select a hiring manager to book a timeslot on behalf of them."}
          {!clientId &&
            !hiringManagerUser &&
            "Please select a client to book a timeslot in behalf of them."}
          {!clientId &&
            !!hiringManagerUser &&
            `You are booking slots for ${hiringManagerUser.firstName}`}
        </Typography>
      )}
    </Grid>
  );
};

export default BookingMessage;
